import { Component } from '@angular/core';
import { NavShareService } from '../../../services/core/nav-share.service';
import { BehaviorSubject, filter, map, tap } from 'rxjs';
import { RouterFacade } from '../../../services/core/router.facade';
import { CustomizationFacade } from '../../../store/customization/customization.facade';
import { AuthenticationFacade } from '../../../store/authentication/authentication.facade';
import { User } from '../../../store/authentication/model/user.model';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
    constructor(
        private navShareService: NavShareService,
        private routerFacade: RouterFacade,
        private customizationFacade: CustomizationFacade,
        private authenticationFacade: AuthenticationFacade,
        private router: Router
    ) {}

    customization$ = this.customizationFacade.customization$;
    collapsed$ = this.navShareService.sidebarCollapsed$;
    user$ = this.authenticationFacade.user$;
    activeMenu$ = this.routerFacade.routeData$.pipe(
        filter((data) => data && data['activeMenu']),
        tap(({ activeMenu }) =>
            this.collapsedItem$.next({
                calendar: activeMenu !== 'calendar',
                contingent: activeMenu !== 'contingent',
                cms: activeMenu !== 'cms'
            })
        ),
        map(({ activeMenu }) => activeMenu)
    );
    collapsedItem$ = new BehaviorSubject<{ [key: string]: boolean }>({
        calendar: true,
        contingent: true,
        cms: true
    });

    userHasOneRoleOf(user: User | null, roles: string[], excludeRoles: string[] = []): boolean {
        let hasRole = false;

        if (user) {
            for (const role of roles) {
                if (user.roles?.includes(role)) {
                    hasRole = true;
                    break;
                }
            }

            if (hasRole) {
                for (const role of excludeRoles) {
                    if (user.roles?.includes(role)) {
                        hasRole = false;
                        break;
                    }
                }
            }
        }

        return hasRole;
    }

    toggleCollapseSubmenu(identifier: string): void {
        this.collapsedItem$.next({
            calendar: identifier !== 'calendar',
            contingent: identifier !== 'contingent',
            cms: identifier !== 'cms'
        });
    }

    navigate(route: string): void {
        void this.router.navigate([route]);
    }
}
